import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import * as moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/app/environments/environments';
import { GenericCrudService } from 'src/app/services/crud/generic-crud.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-new-binnacle-ot',
  templateUrl: './modal-new-binnacle-ot.component.html',
  styleUrls: ['./modal-new-binnacle-ot.component.css']
})
export class ModalNewBinnacleOtComponent {
  requestForm: FormGroup;
  loadingFull: boolean = true;
  loading: any;
  id: string = '';
  type: string = '';
  title: string = 'Agregar mantenimiento a O.T';
  imagePreview: string | null = null;
  photo: File | null = null;
  
  binnacle_ot_date: string | null = null;
  binnacle_ot_comments: string | null = null;

  constructor(
    private fb: FormBuilder,
    public thisModalRef: MdbModalRef<ModalNewBinnacleOtComponent> | null = null,
    private crudService: GenericCrudService<any>
  ) {
    this.requestForm = this.fb.group({
      binnacle_ot_date: [null],
      binnacle_ot_comments: [null],
      photo: new FormControl(null),
    });
  }

  async ngOnInit(): Promise<void> {
    try {
      this.loadingFull = true;
      this.differenceByAction();
      await Promise.all([
        // this.getProductionLine(),
        // this.getProductionSpeciality(),
      ]);
    } catch (error) {
      console.log('[ngOnInit] error: ', error);
    } finally {
      this.loadingFull = false;
    }
  }

  differenceByAction() {
    if(this.type === 'Preventivo') {
      this.title = 'Agregar mantenimiento a O.T';
    } else if(this.type === 'Bitácora') {
      this.title = 'Informe de trabajo';	
    }
  }

  closeModal() {
    this.thisModalRef?.close(true);
  }

  createMaintenance(): void {
    try {
      Swal.fire({
        title: '¿Está seguro de que desea crear este registro?',
        icon: 'warning',
        width: 800,
        customClass: {
          popup: 'custom-swal-popup'
        },
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: 'Procesando...',
            allowOutsideClick: false,
            showCancelButton: false,
            showCloseButton: false,
            showConfirmButton: false,
            willOpen: async () => {
              Swal.showLoading();
              const body = new FormData();
              body.append('table_name', 'MAINTENANCE_OT');
              body.append('action', 'INSERT');

              body.append('id_work_order', this.id);
              // body.append('binnacle_ot_date', moment(this.requestForm.get('binnacle_ot_date')?.value).format('DD-MM-YYYY hh:mm'));
              body.append('binnacle_ot_date', this.requestForm.get('binnacle_ot_date')?.value);
              body.append('binnacle_ot_comments', this.requestForm.get('binnacle_ot_comments')?.value);
              body.append('binnacle_ot_photo', this.requestForm.get('photo')?.value);
              body.append('type', this.type); //preventivo o correctivo
              body.append('active', '1');
              body.append('id_company', localStorage.getItem('IdCompany') ?? '');
              body.append('id_creator_user', localStorage.getItem('IdUser') ?? '');
    
              const response: any = await firstValueFrom(
                this.crudService.crud(body, environment.CreateNewBinnacleOTByIdWorkOrder)
              );
    
              if (response && response.status === 1) {
              //   const bodyMail = new FormData();
              //   bodyMail.append('id_binnacle', this.id);
              //   bodyMail.append('id_user', localStorage.getItem('IdUser') ?? '');
              //   await firstValueFrom(
              //     this.crudService.crud(bodyMail, environment.SendMailApproveOrReject)
              //   );
                Swal.fire({
                  icon: 'success',
                  title: 'Se ha creado correctamente!',
                  showConfirmButton: false,
                  timer: 1500,
                });
                this.closeModal();
              }
            },
          });
        }
      });

    } catch (error) {
      console.error('Error: ', error);
    }
  }

  removeImage(): void {
    this.imagePreview = null;
    this.requestForm.get('photo')?.setValue(null);
    const photo = document.getElementById('photo') as HTMLInputElement;
    if (photo) {
      photo.value = ''; // Limpia el input de archivo
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      this.photo = file;
      this.requestForm.get('photo')?.setValue(this.photo);

      // Crear una URL para previsualizar la imagen
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }
}
